import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {myBatteriesSelector} from "../redux/reducers/myBatteriesReducer";
import {connect} from "react-redux";

class BatterySheet extends Component {
    render() {
        return (
            <div>
                {this.props.myBatteries.map(battery => (
                    <div key={battery.battery_id}>
                        <p>{battery.name}</p>
                    </div>
                ))}
            </div>
        );
    }
}

BatterySheet.propTypes = {

};

const mapStateToProps = state => ({
    myBatteries: myBatteriesSelector(state)
})

export default connect(mapStateToProps)(BatterySheet);